"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduct = exports.isBanner = void 0;
function isBanner(item) {
    return item.listerPosition !== undefined;
}
exports.isBanner = isBanner;
function isProduct(item) {
    return item.productId !== undefined;
}
exports.isProduct = isProduct;
//# sourceMappingURL=ProductTypes.js.map